import { createFormsAppConfig } from './feature-app-configs/create-forms-app-config';
import { FORM_FEATURE_APP_CONTENT } from './feature-app-content/create-form-content';

export const defaultAppConfig = {
  appsUMD: '/assets/forms/forms-umd.js',
  appsCommonsJS: '/assets/forms/forms-commonjs.js',
  appContent: FORM_FEATURE_APP_CONTENT,
  createFunctionInstance: createFormsAppConfig, // createMofaConfig
};
